import API from './index'

class HeadUrl {
  head_url(params) {
    return API.head_url(params).then(response => {
      // console.log(response.data)
      return response.data.data
    }).catch(error => {
      console.log(error)
    })
  }

  //获取群成员
  getGroup_memeber(params) {
    return API.get_group_member(params).then(response => {
      return response.data
    }).catch(error => {
      console.log(error)
    })
  }




}

export default new HeadUrl()



// WEBPACK FOOTER //
// ./src/api/headurl.js